import * as React from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";

const MenusContainer = styled.div`
  margin-top: 6rem;
  @media (max-width: 680px) {
    margin-right: 1.5rem;
  }
`;
const MenusTitle = styled.h2`
  margin-top: 4rem;
  margin-bottom: 0px;
  font-size: 2.2rem;
  text-align: center;
`;
const Menu = styled.div`
  margin-top: 4rem;
`;
const MenuTitle = styled.div`
  font-weight: bold;
  font-style: italic;
  text-transform: capitalize;
  font-size: 1.2em;
`;
const MenuCategoryTitle = styled.h3`
  font-weight: bold;
  margin-top: ${(props) => (props.isFirst ? "1rem" : "5rem")};
`;
const MenuCategory = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 3rem;
  margin-top: 1rem;
`;
const Product = styled.div`
  width: 300px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 1rem;
  padding: 1rem 2rem;
  background: #fff;
  border-radius: 1rem;
  justify-content: space-between;
  @media (max-width: 680px) {
    width: 100%;
  }
`;
const ProductName = styled.div`
  font-size: 1.4rem;
  /* font-weight: bold; */
`;
const ProductImages = styled.div``;
const ProductImage = styled.div`
  &>img {
    width: 100px;
  }
`;

export const Menus = ({ locale, menuApiUrl }) => {
  const [menuDataLoaded, setMenuDataLoaded] = useState(false);
  const [menuApi, setMenuApi] = useState(null);

	useEffect(() => {
    if (menuApiUrl) {
      // Fetch data will be cached for 24 hours.  IF expired, data will be fetched again.
      const fetchMenuApiData = async () => {
        // debugger
        const localData = localStorage.getItem(menuApiUrl);
        const now = new Date().getTime();

        if (localData) {
          const parsedData = JSON.parse(localData);
          if (now - parsedData.timestamp < 24 * 60 * 60 * 1000) {
            setMenuApi(parsedData.data);
            setMenuDataLoaded(true);
            return;
          } else {
            localStorage.removeItem(menuApiUrl);
          }
        }

        const url = `https://api.allorigins.win/get?url=${encodeURIComponent(menuApiUrl)}`;
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            mode: 'cors',
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const jsonResponse = await response.json();
          const data = JSON.parse(jsonResponse.contents);
          setMenuApi(data);
          setMenuDataLoaded(true);
          localStorage.setItem(menuApiUrl, JSON.stringify({ data, timestamp: now }));
          // You can add any additional logic to handle the fetched data here
        } catch (error) {
          console.error("Error fetching menu API data:", error);
        }
      };

      fetchMenuApiData();
    }

  }, [menuApiUrl]);

	return (
    <>
      {!menuDataLoaded && <div style={{textAlign: "center", marginTop: "4rem"}}>{locale === "en" ? "Loading menus..." : "載入選單中..."}</div>}
      {menuDataLoaded && menuApi && menuApi.data?.menus?.length > 0 && <MenusContainer>
        <MenusTitle>{locale === "en" ? "Menus" : "餐單"}</MenusTitle>
        {menuDataLoaded && menuApi && menuApi.data?.menus?.length > 0 && menuApi.data.menus.map((menu, index) => {
          return <Menu key={index}>
            {/* <MenuTitle>{menu.name}</MenuTitle> */}
            {menu.menu_categories
              .filter(category => !category.name.toLowerCase().includes("set") && !category.name.toLowerCase().includes("combo") && !category.name.toLowerCase().includes("套餐") && !category.name.toLowerCase().includes("定食"))
              .map((category, index) => {
                const hasImages = category.products.some(product => product.images.length > 0);
                if (hasImages) {
                  return (<>
                    <MenuCategoryTitle isFirst={index === 0}>{category.name}</MenuCategoryTitle>                
                    <MenuCategory key={index}>
                      {category.products.map((product, index) => {
                        if (product.images.length > 0) {
                          return <Product key={index}>
                            <ProductName>{product.name}</ProductName>
                            <ProductImages>
                              {product.images.map((image, index) => {
                                return <ProductImage key={index}>
                                  <img src={image.image_url} alt={product.name} />  
                                </ProductImage>
                              })}
                            </ProductImages>
                          </Product>
                        } else {
                          return null;
                        }
                      })}
                    </MenuCategory>
                  </>)
                } else {
                  return null;
                }
              })}
          </Menu>
        })}
      </MenusContainer>}
    </>
  )
}
